export const DEFAULT_SETTINGS = {
  pendo: {
    /* Default URL for Pendo CDN */
    url: 'https://cdn.pendo.io/agent/static/',
    /* Api key for Pendo web application
     */
    key: '431fb383-5336-4abb-5a92-1bb280733596'
  }
};
